module.exports = __webpack_public_path__ + "static/brasil-2b2977dc27d99edc4646eaf77aa24764.png";